<button v2Ripple [type]="type" [ngClass]="color">
  <ng-content></ng-content>
</button>
